// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3EOyO","inputWrap":"Table_inputWrap__3rM1t","col":"Table_col__3dm_b","bmiTooltip":"Table_bmiTooltip__2cs0f"};